import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">视频推荐</h2>
          <p className="text-sm text-foreground-500 mt-2">精彩内容一睹为快</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group rounded-lg overflow-hidden cursor-pointer transition-all duration-200"
              style={{ backgroundColor: 'oklch(var(--background-50))' }}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full aspect-video object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'oklch(var(--primary-500) / 0.85)' }}>
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-xs text-white" style={{ backgroundColor: 'oklch(var(--foreground-900) / 0.7)' }}>
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{item.views} 次观看</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}